import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

let SESSION_ID = null;

async function get(path) {
  const { data } = await api.get(path);
  return data;
}

export const useBranding = () => useQuery({ queryKey: ["branding"], queryFn: () => get("/public/branding") });
export const useKioskSettings = () => useQuery({ queryKey: ["kioskcfg"], queryFn: () => get("/public/kiosk") });
export const useSolutions = () => useQuery({ queryKey: ["pub-solutions"], queryFn: () => get("/public/solutions") });
export const useIndustries = () => useQuery({ queryKey: ["pub-industries"], queryFn: () => get("/public/journey-industries"), enabled: false });
export const useIndustriesList = () => useQuery({ queryKey: ["pub-industries"], queryFn: () => get("/public/industries") });
export const useJourney = () => useQuery({ queryKey: ["journey"], queryFn: () => get("/public/journey") });
export const useContact = () => useQuery({ queryKey: ["contact"], queryFn: () => get("/public/contact") });

export async function startSession() {
  try {
    const { data } = await api.post("/public/session");
    SESSION_ID = data.session_id;
    return SESSION_ID;
  } catch {
    return null;
  }
}

export async function endSession(completed = false) {
  if (!SESSION_ID) return;
  try {
    await api.post("/public/session/end", { session_id: SESSION_ID, completed });
  } catch {}
  SESSION_ID = null;
}

export async function logEvent(type, label = null, entity_id = null) {
  try {
    await api.post("/public/events", { session_id: SESSION_ID, type, label, entity_id });
  } catch {}
}

export async function getEmailStatus() {
  try {
    const { data } = await api.get("/public/email-status");
    return data.configured;
  } catch {
    return false;
  }
}

export async function submitLead(payload) {
  const { data } = await api.post("/public/leads", payload);
  return data;
}

export async function sendDocument(payload) {
  const { data } = await api.post("/public/send-document", payload);
  return data;
}
